import { Component, OnInit } from '@angular/core';
import {UserStatusesService} from '../user-statuses.service';
import {SharedDataService} from '../invited-shared-data.service';

@Component({
  selector: 'app-invited',
  templateUrl: './invited.component.html',
  styleUrls: ['./invited.component.less']
})
export class InvitedComponent implements OnInit {

  invited = [];
  showSpinner = false;
  emailInvitedSearch = '';
  pageSize = 50;
  currentPage = 0;
  end: number = this.pageSize;
  totalCountOfInvited = 0;
  start = 0;
  private searchTimer: any;
  private isTimerExpired = false;
  pageSizeOptions = [25, 50, 100];

  constructor(private userStatusesService: UserStatusesService, private sharedDataService: SharedDataService) {
  }

  ngOnInit() {
    this.getInvitedPage();
  }
  searchInvitedEmail() {
    clearTimeout(this.searchTimer);
    this.isTimerExpired = false;
    if (this.emailInvitedSearch && this.emailInvitedSearch.length >= 3) {
      this.searchTimer = setTimeout(() => {
        this.isTimerExpired = true;
        this.currentPage = 0;
        this.getInvitedPage();
      }, 2000);
    }
  }

  onPageSizeChange(): void {
    this.getInvitedPage();
  }
  handleInvitedBackspace(event: KeyboardEvent) {
    if ((event.keyCode === 8 && this.emailInvitedSearch.trim() === '') || (this.emailInvitedSearch && this.emailInvitedSearch.length >= 3)) {
      this.searchTimer = setTimeout(() => {
        this.isTimerExpired = true;
        this.currentPage = 0;
        this.getInvitedPage();
      }, 2000);
    }
  }
  searchInvitedOnEnter() {
    this.currentPage = 0;
    this.getInvitedPage();
  }
  resetInvited() {
    this.currentPage = 0;
    this.emailInvitedSearch = '';
    this.getInvitedPage();
  }

  nextPageInvited() {
    if (this.end >= this.totalCountOfInvited) {
      return;
    }
    if ((this.start + this.pageSize) > this.totalCountOfInvited) {
      this.start = this.totalCountOfInvited - this.end;
      this.end = this.totalCountOfInvited;
    } else {
      this.start = this.start + this.pageSize;
    }
    this.currentPage += 1;
    this.getInvitedPage();
  }

  previousPageInvited() {
    if (this.currentPage === 0) {
      return;
    }
    this.start = this.start - this.pageSize;
    this.currentPage -= 1;
    this.getInvitedPage();
  }

  private getInvitedPage() {
    this.showSpinner = true;
    this.userStatusesService.fetchInvited(
      this.currentPage,
      this.emailInvitedSearch,
      this.pageSize).subscribe(this.extractData);
    this.updateValues();
  }

  private extractData = data => {
    this.totalCountOfInvited = data.totalItems;
    this.end =  parseInt((this.start + this.pageSize > this.totalCountOfInvited ?
      this.totalCountOfInvited : this.start + this.pageSize).toString(), 10);
    this.currentPage = data.currentPage;
    this.invited = data.invites;
    this.showSpinner = false;
  }

  updateValues() {
    this.sharedDataService.updateEmailInvitedSearch(this.emailInvitedSearch);
    this.sharedDataService.updatePageSize(this.pageSize);
    this.sharedDataService.updateCurrentPage(this.currentPage);
  }

}
